export * as data from '@wix/auto_sdk_data-backend-public-sdk-poc_data/meta';
